export default {
    currentItem: state => state.flowchart.currentItem,//流程图编辑
    toolList: state => state.flowchart.toolList,//流程图编辑
    log: state => state.flowchart.log
}